import { Box, Menu, MenuItem } from "@mui/material";
import MuiButton from "@mui/material/Button";
import withStyles from '@mui/styles/withStyles';
import { ArrowDropDown } from "@mui/icons-material";
import { MouseEvent, useState, useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { useFocusStyles } from "hooks/focusBorder";
import { useTranslation } from "react-i18next";
import { useStyles } from "./selectStyles";

const DesktopButton = withStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey["A100"]}`,
    borderRadius: 0,
    color: theme.palette.grey["800"],
    padding: "5px 10px",
    fontSize: "12px",
    textTransform: "none",
  },
}))(MuiButton);

const MobileButton = withStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey["A100"]}`,
    borderRadius: 0,
    color: theme.palette.grey["800"],
    padding: "5px 5px 5px 10px",
    fontSize: "12px",
    lineHeight: "14px",
    textTransform: "none",
  },
  endIcon: {
    marginLeft: "2px",
  },
}))(MuiButton);

const Button = (props: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const style = { ...props.style, width: props.width };
  return isMobile ? (
    <MobileButton {...props} style={style} />
  ) : (
    <DesktopButton {...props} style={style} />
  );
};

export interface option {
  title: string;
  id: any;
}

export const Select = ({
  title,
  options,
  onChange,
  toggle,
  pagenation,
  width,
  value,
  buttonLabelId,
  endIcon,
  customClass,
}: any): React.ReactElement => {
  const [label, setLabel] = useState<string | null>(title);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const focusClass = useFocusStyles();
  const classes = useStyles();
  useEffect(() => {
    if (pagenation) {
      setLabel(title);
    }
    setLabel(title);
  }, [title]);

  useEffect(() => {
    if (options && options.length > 0 && !toggle) {
      const label = options.find((option: any) => option.id === value);
      if (label) {
        setLabel(label.title);
      } else {
        setLabel(title);
      }
    }
  }, [value, options, title, toggle]);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    if (!toggle) {
      setAnchorEl(event.currentTarget);
    } else if (options.length === 1) {
      onChange(options[0].id);
    } else if (options.length > 1) {
      const nextOption = options.find((option: any) => option.title !== label);
      if (nextOption) {
        setLabel(nextOption.title);
        onChange(nextOption.id);
        handlefocus(nextOption.title);
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { t } = useTranslation();

  const handlefocus = (btntitle: string) => {
    if (btntitle == t("show_filters_button")) {
      document
        .querySelector("#btnfilter-" + title.replace(" ", "-"))
        ?.setAttribute("aria-expanded", "false");
    } else if (btntitle == t("hide_filters_button")) {
      document
        .querySelector("#btnfilter-" + title.replace(" ", "-"))
        ?.setAttribute("aria-expanded", "true");
    }
  };

  return (
    <Box>
      <Button
        id={`btnfilter-${title.replace(" ", "-")}`}
        aria-controls={`${title}-menu`}
        onClick={handleOpen}
        endIcon={endIcon || <ArrowDropDown />}
        width={width}
        className={`${customClass} ${focusClass.focusItem}`}
        onFocus={() => handlefocus(label)}
        aria-expanded={Boolean(anchorEl) ? "true" : "false"}
        aria-haspopup="listbox"
        aria-labelledby={`${buttonLabelId} btnfilter-${title.replace(" ", "-")}`}
        title={label}
      >
        <span id={label}>{label}</span>
      </Button>
      {options && options.length > 0 && (
        <Menu
          id={`${title}-menu`}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          aria-expanded={Boolean(anchorEl) ? "true" : "false"}
          role="listbox"
          MenuListProps={{
            role: "listbox",
            "aria-labelledby": buttonLabelId,
          }}
        >
          {options.map((item: any, idx: number) => {
            return (
              <MenuItem
                key={idx}
                id={item.id}
                onClick={() => {
                  if (onChange) {
                    onChange(item.id);
                  }
                  setLabel(item.title);
                  handleClose();
                }}
                className={`${customClass || classes.menuItemClass} ${focusClass.focusItem}`}
                role="option"
                aria-selected={item.title === label}
                onFocus={(e) => {
                  const ulList = document.querySelector(`[id='${title}-menu'] .MuiList-root`);
                  ulList && ulList.setAttribute("aria-activedescendant", e.currentTarget.id);
                }}
              >
                {item.title}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </Box>
  );
};
